import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { AuthShell } from "@/components/AuthShell";
import { PasswordInput } from "@/components/PasswordInput";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Loader2, ArrowLeft } from "lucide-react";
import { toast } from "sonner";

export default function AtivarAcesso() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const { refresh } = useAuth();
  const [nova, setNova] = useState("");
  const [conf, setConf] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (nova.length < 6) return toast.error("A senha deve ter ao menos 6 caracteres");
    if (nova !== conf) return toast.error("As senhas não conferem");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/accept-invite", { token, password: nova });
      localStorage.setItem("nexolog_token", data.token);
      await refresh();
      toast.success("Acesso ativado! Bem-vindo(a) ao NEXO LOG.");
      nav("/");
    } catch (e2) { toast.error(e2.response?.data?.detail || "Não foi possível ativar o acesso"); }
    finally { setLoading(false); }
  };

  if (!token) {
    return (
      <AuthShell title="Convite inválido" subtitle="O link de convite está incompleto ou expirou."
        footer={<Link to="/login" className="flex items-center gap-1 text-sm text-primary mt-2"><ArrowLeft className="w-4 h-4" /> Ir para o login</Link>} >
        <div />
      </AuthShell>
    );
  }

  return (
    <AuthShell title="Ative seu acesso" subtitle="Crie sua senha pessoal para começar a usar o NEXO LOG." >
      <form onSubmit={submit} className="space-y-5" data-testid="invite-form">
        <div className="space-y-2"><Label>Nova senha</Label>
          <PasswordInput value={nova} onChange={(e) => setNova(e.target.value)} data-testid="invite-nova" /></div>
        <div className="space-y-2"><Label>Confirmar nova senha</Label>
          <PasswordInput value={conf} onChange={(e) => setConf(e.target.value)} data-testid="invite-conf" /></div>
        <Button type="submit" className="w-full h-12 text-base font-bold" disabled={loading} data-testid="invite-submit">
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Ativar acesso"}
        </Button>
      </form>
    </AuthShell>
  );
}
